var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-travel-purpose" }, [
    _c("header", { staticClass: "tls-simple-banner" }, [
      _c("div", { staticClass: "tls-home-text-group" }, [
        _c("h1", { staticClass: "tls-heading-1" }, [
          _vm._v(_vm._s(_vm._.get(_vm.travelPurposeCmsData, "bannerTitle")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tls-simple-text -color-white -size-20" }, [
          _vm._v(_vm._s(_vm._.get(_vm.travelPurposeCmsData, "bannerSubTitle")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tls-static-content tls-travel-purpose-content" },
      [
        _c("div", { staticClass: "tls-travel-purpose-info" }, [
          _c("div", { staticClass: "tls-large-card-info" }, [
            _c("div", { staticClass: "tls-card-lg" }, [
              _c("div", {
                directives: [
                  {
                    name: "dompurify-html",
                    rawName: "v-dompurify-html",
                    value: _vm._.get(_vm.travelPurposeCmsData, "cardTitle"),
                    expression: "_.get(travelPurposeCmsData, 'cardTitle')"
                  }
                ],
                staticClass: "tls-simple-text -size-16"
              })
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tls-travel-purpose-registration" }, [
          _c("div", { staticClass: "tls-travel-purpose-registration--slot" }, [
            _c("h2", { staticClass: "tls-heading-2" }, [
              _vm._v(_vm._s(_vm._.get(_vm.travelPurposeCmsData, "actionTitle")))
            ])
          ]),
          _vm._v(" "),
          _vm.isRegistrationEnabled &&
          !_vm._.get(_vm.travelPurposeCmsData, "hide_register_button")
            ? _c(
                "div",
                { staticClass: "tls-travel-purpose-registration--slot" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "tls-button-primary",
                      attrs: { target: "_blank", rel: "noopener noreferrer" },
                      on: {
                        click: function($event) {
                          return _vm.openRegister()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._.get(_vm.travelPurposeCmsData, "actionButton")
                        )
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tls-travel-purpose-registration--slot" }, [
            _c("div", { staticClass: "tls-travel-purpose-registration-text" }, [
              _c("div", {
                directives: [
                  {
                    name: "dompurify-html",
                    rawName: "v-dompurify-html",
                    value: _vm._.get(_vm.travelPurposeCmsData, "actionDesc"),
                    expression: "_.get(travelPurposeCmsData, 'actionDesc')"
                  }
                ],
                staticClass: "tls-simple-text -size-16"
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.issuer && _vm.residenceCountryCode
          ? _c(
              "div",
              [
                _c("visa-subtype-selection", {
                  attrs: {
                    issuer: _vm.issuer,
                    residenceCountryCode: _vm.residenceCountryCode
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-large-card-info--decoration" }, [
      _c("div", { staticClass: "tls-decoration-vertical-lines -blue" }, [
        _c("div", { staticClass: "tls-line1" }),
        _vm._v(" "),
        _c("div", { staticClass: "tls-line2" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }